// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type TaskCatalogLaborCostsPageQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.BidItemEstimateFilter>;
  page?: Types.InputMaybe<Types.PageFilter>;
}>;


export type TaskCatalogLaborCostsPageQuery = { __typename?: 'Query', bidItemEstimates: { __typename?: 'BidItemEstimatesPageResult', entities: Array<{ __typename: 'BidItemEstimate', id: string, createdAt: Types.Scalars['DateTime']['input'], costInMills: number, sourceUrl?: string | null | undefined, createdBy: { __typename?: 'User', id: string, name: string }, markets: Array<{ __typename?: 'Market', id: string, name: string }>, bidItemEstimate: { __typename?: 'BidItem', id: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string, abbreviation: string } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, totalCount: number } } };

export type TaskCatalogLaborCostsPage_BidItemEstimateFragment = { __typename?: 'BidItemEstimate', id: string, createdAt: Types.Scalars['DateTime']['input'], costInMills: number, sourceUrl?: string | null | undefined, createdBy: { __typename?: 'User', id: string, name: string }, markets: Array<{ __typename?: 'Market', id: string, name: string }>, bidItemEstimate: { __typename?: 'BidItem', id: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string, abbreviation: string } } };

export const TaskCatalogLaborCostsPage_BidItemEstimateFragmentDoc = gql`
    fragment TaskCatalogLaborCostsPage_BidItemEstimate on BidItemEstimate {
  id
  createdAt
  createdBy {
    id
    name
  }
  costInMills
  markets {
    id
    name
  }
  sourceUrl
  bidItemEstimate: bidItem {
    id
    unitOfMeasure {
      id
      abbreviation
    }
  }
}
    `;
export const TaskCatalogLaborCostsPageDocument = gql`
    query TaskCatalogLaborCostsPage($filter: BidItemEstimateFilter, $page: PageFilter) {
  bidItemEstimates(filter: $filter, page: $page) {
    entities {
      __typename
      ... on BidItemEstimate {
        ...TaskCatalogLaborCostsPage_BidItemEstimate
      }
    }
    pageInfo {
      hasNextPage
      totalCount
    }
  }
}
    ${TaskCatalogLaborCostsPage_BidItemEstimateFragmentDoc}`;

/**
 * __useTaskCatalogLaborCostsPageQuery__
 *
 * To run a query within a React component, call `useTaskCatalogLaborCostsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskCatalogLaborCostsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskCatalogLaborCostsPageQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useTaskCatalogLaborCostsPageQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TaskCatalogLaborCostsPageQuery, TaskCatalogLaborCostsPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TaskCatalogLaborCostsPageQuery, TaskCatalogLaborCostsPageQueryVariables>(TaskCatalogLaborCostsPageDocument, options);
      }
export function useTaskCatalogLaborCostsPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TaskCatalogLaborCostsPageQuery, TaskCatalogLaborCostsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TaskCatalogLaborCostsPageQuery, TaskCatalogLaborCostsPageQueryVariables>(TaskCatalogLaborCostsPageDocument, options);
        }
// @ts-ignore
export function useTaskCatalogLaborCostsPageSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TaskCatalogLaborCostsPageQuery, TaskCatalogLaborCostsPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TaskCatalogLaborCostsPageQuery, TaskCatalogLaborCostsPageQueryVariables>;
export function useTaskCatalogLaborCostsPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TaskCatalogLaborCostsPageQuery, TaskCatalogLaborCostsPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TaskCatalogLaborCostsPageQuery | undefined, TaskCatalogLaborCostsPageQueryVariables>;
export function useTaskCatalogLaborCostsPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TaskCatalogLaborCostsPageQuery, TaskCatalogLaborCostsPageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TaskCatalogLaborCostsPageQuery, TaskCatalogLaborCostsPageQueryVariables>(TaskCatalogLaborCostsPageDocument, options);
        }
export type TaskCatalogLaborCostsPageQueryHookResult = ReturnType<typeof useTaskCatalogLaborCostsPageQuery>;
export type TaskCatalogLaborCostsPageLazyQueryHookResult = ReturnType<typeof useTaskCatalogLaborCostsPageLazyQuery>;
export type TaskCatalogLaborCostsPageSuspenseQueryHookResult = ReturnType<typeof useTaskCatalogLaborCostsPageSuspenseQuery>;
export type TaskCatalogLaborCostsPageQueryResult = Apollo.QueryResult<TaskCatalogLaborCostsPageQuery, TaskCatalogLaborCostsPageQueryVariables>;